/**
 * Where to send someone after they sign in, when they were on their way
 * somewhere else — an invite link, most of the time.
 *
 * Only in-app paths are honoured: a `next` pointing at another site would
 * make the login page a redirector for whoever crafted the URL. The second
 * character has to be checked for a backslash as well as a slash — browsers
 * read "/\evil.com" as "//evil.com" and leave the site.
 */
export const safeNext = (value: string | null | undefined): string | null => {
  if (!value || !value.startsWith('/')) return null;
  if (value[1] === '/' || value[1] === '\\') return null;
  return value;
};

/** The `next` on the current URL, if it is one we will follow. */
export const nextFromLocation = (search?: string): string | null => {
  const query = search ?? (typeof window !== 'undefined' ? window.location.search : '');
  return safeNext(new URLSearchParams(query).get('next'));
};

/** Where to go after signing in: the requested page, or the app's front door. */
export const afterAuthPath = (search?: string): string => nextFromLocation(search) || '/';
